document.addEventListener('DOMContentLoaded', () => {
  const wishlistButtons = document.querySelectorAll('.wishlist-btn');
  const countElement = document.querySelector('.wish-icon .cart-count-bubble span');

  // Helper function to update count display
 function updateWishlistCount() {
  const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

  if (countElement) {
    const cartBubble = countElement.closest('.cart-count-bubble');

    // Update count text
    countElement.textContent = wishlist.length;

    // Show or hide the closest .cart-count-bubble
    if (cartBubble) {
      if (wishlist.length > 0) {
        cartBubble.style.display = 'inline-flex';
      } else {
        cartBubble.style.display = 'none';
      }
    }
  }
}


  // Initialize count on page load
  updateWishlistCount();

  wishlistButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const handle = btn.dataset.handle;
      let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

      if (wishlist.includes(handle)) {
        wishlist = wishlist.filter(item => item !== handle);
        btn.classList.remove('active');
      } else {
        wishlist.push(handle);
        btn.classList.add('active');
      }

      localStorage.setItem('wishlist', JSON.stringify(wishlist));

      // Update the count after modification
      updateWishlistCount();
    });

    // Highlight saved items
    const handle = btn.dataset.handle;
    const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    if (wishlist.includes(handle)) {
      btn.classList.add('active');
    }
  });

  function formatShopifyMoney(cents) {
  // Safely format based on the current storefront currency
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, Shopify.currency.active);
  }

  // Fallback if Shopify global is not available
  const currency = window.Shopify?.currency?.active || document.documentElement.getAttribute('data-shopify-currency') || 'USD';
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency,
  }).format(cents / 100);
}

let storedWishlist = [];

if (localStorage.getItem('wishlist')) {
  storedWishlist = JSON.parse(localStorage.getItem('wishlist'));
}  //console.log('Stored wishlist:', storedWishlist);
//   alert(storedWishlist);

  let wishlistContainer = document.querySelector('#wishlist-container');
  if(wishlistContainer){
  //console.log('Wishlist container found:', !!wishlistContainer);

  if (!wishlistContainer) return;

  let wishlist = storedWishlist;
  //console.log(wishlist);

  if (wishlist.length === 0) {
    wishlistContainer.innerHTML = '<p>Your wishlist is empty.</p>';
    return;
  }
  document.querySelector("#wishlist-page h1").innerHTML = 'Your Wishlist ('+wishlist.length+ ')';
  

  wishlistContainer.innerHTML = '<p>Loading wishlist...</p>';
  wishlistContainer.innerHTML = '';

  wishlist.forEach(handle => {

    fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
      .then(response => {
       
        return response.json();
      })
      .then(product => {
    
        
        if (!product || !product.title) return;
        const priceHTML = typeof Shopify !== 'undefined' && Shopify.formatMoney
  ? Shopify.formatMoney(product.price)
  : (product.price / 100).toFixed(2) + ' ' + (Shopify?.currency?.active || '');
        const productHTML = `

        <li class="grid__item">
          <div class="card-wrapper product-card-wrapper underline-links-hover">
            <div class="card card--standard card--media">
              <div class="card__inner">
                <div class="card__media">
                  <div class="media media--transparent media--hover-effect">
                    <img 
                      src="${product.images[0]}"
                      alt="${product.title}" class="motion-reduce" loading="lazy" >
                  </div>
                </div>
                <div class="">
                  <div class="">
                    <h3 class="card__heading">
                      <a href="${product.url}"
                        class="full-unstyled-link">
                        ${product.title}
                      </a>
                      <p>${formatShopifyMoney(product.price)}</p>
                    </h3>
                  </div>
                </div>
                <button 
              class="remove-wishlist active" data-handle="${product.handle}"
              type="button" 
              aria-label="Add to Wishlist">
              
              <svg width="18" height="18" viewBox="0 0 17 17" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_12_2)">
                      <path d="M8.86956 15.7804L7.79782 14.8048C3.9913 11.353 1.47826 9.07652 1.47826 6.28261C1.47826 4.00609 3.26695 2.21739 5.54347 2.21739C6.82956 2.21739 8.06391 2.81609 8.86956 3.76217C9.67521 2.81609 10.9096 2.21739 12.1956 2.21739C14.4722 2.21739 16.2609 4.00609 16.2609 6.28261C16.2609 9.07652 13.7478 11.353 9.9413 14.8122L8.86956 15.7804Z" stroke="black" stroke-width="1.5"></path>
                      </g>
                      <defs>
                      <clipPath id="clip0_12_2">
                      <rect width="17" height="17" fill="white"></rect>
                      </clipPath>
                      </defs>
                      </svg>
            </button>
            </div>
          </div>
        </li>
        `;
        
        wishlistContainer.insertAdjacentHTML('beforeend', productHTML);
      })
      .catch(err => console.error('Error fetching product:', err));
  });

wishlistContainer.addEventListener('click', function (e) {
    // If you click on a child element inside the button, use closest()
    const removeButton = e.target.closest('.remove-wishlist');
    if (!removeButton) return;

    const handle = removeButton.dataset.handle;
    let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

    // Remove selected item
    wishlist = wishlist.filter(item => item !== handle);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    // Remove <li> from DOM
    const listItem = removeButton.closest('li');
    if (listItem) listItem.remove();

    // Update wishlist count bubble
    const countBubble = document.querySelector('.wish-icon .cart-count-bubble span');
    if (countBubble) {
      countBubble.textContent = wishlist.length;
    }

      document.querySelector("#wishlist-page h1").innerHTML = 'Your Wishlist ('+wishlist.length+ ')';


    // Show empty message if wishlist is empty
    if (wishlist.length === 0) {
      wishlistContainer.innerHTML = '<p>Your wishlist is empty.</p>';
    }
  });

  }
});





